import React from 'react';
import { Link } from 'react-router-dom';
import { I18n } from "aws-amplify";
import { Card, Table, Spinner } from 'react-bootstrap';
import { parseAsMoment } from './../../../shared/utils/date'

const NewLicencesCard = ({ loading, licences, totalCount, limit = 10 }) => {

  const list = (licences || []).slice(0, limit);

  // ユーザ詳細ページへのリンク情報
  const goUserPage = (argUserId) => ({
    pathname: `/user/${argUserId}`
  });
  
  // ライセンス詳細ページへのリンク情報
  const goLicencePage = (argLicenceId, argUserId) => ({
    pathname: `/licence/${argLicenceId}`,
    state: { userId: argUserId },
  });

  const headerText = totalCount
    ? `新規ライセンス（期間内／合計 ${totalCount} 件・最新 ${limit} 件）`
    : `新規ライセンス（期間内／最新 ${limit} 件）`;

    return (
    <Card>
       <Card.Header>{headerText}</Card.Header>
      <Card.Body className="p-2">
        <Table size="sm" hover responsive className="text-nowrap">
          <thead>
            <tr>
              <th>ユーザ名</th>
              <th>ライセンスID</th>
              <th>発行日</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={3} className="text-center">
                  <div className="text-center py-3">
                    <Spinner
                      as="span"
                      animation="border"
                      role="status"
                      aria-hidden="true"
                    />
                  </div>
                </td>
              </tr>
            ) : list.length === 0 ? (
              <tr>
                <td colSpan={3} className="text-center text-muted">
                  データがありません
                </td>
              </tr>
            ) : (
              list.map((lic) => (
                <tr key={lic.id}>
                  <td>
                      <Link
                        to={goUserPage(lic.userId)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {lic.username}
                      </Link>{' '}
                  </td>
                  <td>
                      <Link 
                        to={goLicencePage(lic.id, lic.userId)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {lic.licenceKey}
                      </Link>{' '}
                  </td>
                  <td>
                    {lic.createdAt
                      ? parseAsMoment(lic.createdAt).format('YYYY年MM月DD日 HH:mm')
                      : ''}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default NewLicencesCard;
